import "./CopyrightSection.scss";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const CopyrightSection = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <div className="copyright-section">
      <div className="copy-text">{t("footer.copyText", { year: year })}</div>
      <div className="copy-text">
        {/* {t("footer.privacyNotice")} <div></div> */}
        <Trans
          i18nKey="footer.cookie"
          components={{
            cookie: <a href="/Cookies Policy.pdf" target="_blank" />,
          }}
        />
        {/* <div></div> {t("footer.preferences")} */}
      </div>
    </div>
  );
};

export default CopyrightSection;
